var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "Artist Bio Management" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "pb-6 flex justify-between items-center" },
                  [
                    _c(
                      "div",
                      { staticClass: "flex items-center" },
                      [
                        _c(
                          "div",
                          { staticClass: "mr-2" },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "search name" },
                              on: { change: _vm.search },
                              model: {
                                value: _vm.filter,
                                callback: function($$v) {
                                  _vm.filter = $$v
                                },
                                expression: "filter"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("Button", {
                          attrs: { label: "Apply" },
                          on: { clicked: _vm.search }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          { staticClass: "p-2" },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: ["fas", "sync"] },
                              on: { click: _vm.reset }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "data-tables-server",
                  {
                    ref: "tableArtist",
                    attrs: {
                      data: _vm.data,
                      total: _vm.total,
                      "pagination-props": {
                        background: true,
                        pageSizes: [20, 50, 100, 300, 500]
                      }
                    },
                    on: { "query-change": _vm.onChangeTable }
                  },
                  [
                    _vm._l(_vm.titles, function(title) {
                      return _c("el-table-column", {
                        key: title.prop.field,
                        attrs: {
                          prop: title.prop.field,
                          label: title.label,
                          sortable: "custom",
                          width: title.prop.width
                        }
                      })
                    }),
                    _vm._v(" "),
                    _vm.isSuperAdmin || _vm.isAdmin || _vm.isOps
                      ? _c("el-table-column", {
                          attrs: {
                            label: "Actions",
                            align: "right",
                            width: "auto"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "static inline-block text-left container-action"
                                      },
                                      [
                                        _c(
                                          "VueCustomTooltip",
                                          {
                                            attrs: {
                                              label: "Approve",
                                              position: "is-left"
                                            }
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "p-2 w-8 mr-2 rounded bg-green-500 hover:bg-green-600 focus:outline-none",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.approvalBio(
                                                      scope.row,
                                                      true
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "text-white",
                                                  attrs: {
                                                    icon: ["fa", "check"]
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "VueCustomTooltip",
                                          {
                                            attrs: {
                                              label: "Detail",
                                              position: "is-left"
                                            }
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "p-2 w-8 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.detail(scope.row)
                                                  }
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "text-white",
                                                  attrs: { icon: ["fa", "eye"] }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "VueCustomTooltip",
                                          {
                                            attrs: {
                                              label: "Edit",
                                              position: "is-left"
                                            }
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "p-2 w-8 mr-2 rounded bg-orange-500 hover:bg-orange-600 focus:outline-none",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.editBio(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "text-white",
                                                  attrs: {
                                                    icon: ["fa", "pencil-alt"]
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3606394519
                          )
                        })
                      : _vm._e()
                  ],
                  2
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "editBio",
          attrs: {
            isShowingModal: _vm.isShowingModalEdit,
            isLoading: _vm.isLoading,
            error: _vm.isError,
            labelSubmit: "Save",
            title: "Edit Bio"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModalEdit = !_vm.isShowingModalEdit
            },
            save: function($event) {
              return _vm.submitEditBio(_vm.artist)
            }
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c(
              "div",
              { staticClass: "py-6", staticStyle: { "min-width": "560px" } },
              [
                _c("form-item", { attrs: { label: "Artist Name" } }, [
                  _c("p", { staticClass: "text-left font-bold" }, [
                    _vm._v(_vm._s(_vm.artist.name))
                  ])
                ]),
                _vm._v(" "),
                _c("form-item", {
                  attrs: { label: "Bio" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            { staticClass: "relative" },
                            [
                              _c("TextArea", {
                                attrs: {
                                  placeholder: "Bio",
                                  maxlength: _vm.maxLengthBio,
                                  rows: "10"
                                },
                                model: {
                                  value: _vm.artist.bio,
                                  callback: function($$v) {
                                    _vm.$set(_vm.artist, "bio", $$v)
                                  },
                                  expression: "artist.bio"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "absolute right-0 text-xs",
                                  staticStyle: { bottom: "15px", right: "15px" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.artist.bio.length) +
                                      "/" +
                                      _vm._s(_vm.maxLengthBio)
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                })
              ],
              1
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialogDetail",
        {
          ref: "detailBio",
          attrs: {
            isShowingModal: _vm.isShowingModalDetail,
            isLoading: _vm.isLoading,
            title: "Bio Details"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModalDetail = !_vm.isShowingModalDetail
            }
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c(
              "div",
              { staticClass: "py-6", staticStyle: { "min-width": "360px" } },
              [
                _c("form-item", { attrs: { label: "Artist Name" } }, [
                  _c("p", { staticClass: "text-left font-bold" }, [
                    _vm._v(_vm._s(_vm.artist.name))
                  ])
                ]),
                _vm._v(" "),
                _c("form-item", { attrs: { label: "Bio" } }, [
                  _c("p", { staticClass: "text-left font-bold" }, [
                    _vm._v(_vm._s(_vm.artist.bio))
                  ])
                ])
              ],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-670a6a12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-670a6a12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ArtistBio.vue
// module id = null
// module chunks = 